import { Injectable } from '@angular/core';
import { PghUserDeviceBase } from './pgh-user-device';
import { cloneDeep as _cloneDeep, remove as _remove } from 'lodash';

const SELECTED_DEVICE_LOCAL_STORAGE_KEY = 'Pgh.DeviceInventory.SelectedDevice';
const ALL_DEVICES_LOCAL_STORAGE_KEY = 'Pgh.DeviceInventory.AllDevices';

@Injectable({
  providedIn: 'root'
})
export class SelectedDeviceService {

  private selectedDevice: PghUserDeviceBase | undefined = undefined;
  private allDevices: PghUserDeviceBase[] | undefined = undefined;

  public constructor() {
    const deviceString = (localStorage.getItem(SELECTED_DEVICE_LOCAL_STORAGE_KEY) ?? '').trim();
    if (deviceString.length > 0) {
      this.selectedDevice = JSON.parse(deviceString) ?? undefined;
    }

    const allDevicesString = (localStorage.getItem(ALL_DEVICES_LOCAL_STORAGE_KEY) ?? '').trim();
    if (allDevicesString.length > 0) {
      this.allDevices = JSON.parse(allDevicesString) ?? undefined;
    }
  }

  public getSelectedDevice(): PghUserDeviceBase | undefined {
    return _cloneDeep(this.selectedDevice);
  }

  public setSelectedDevice(device: PghUserDeviceBase) {
    if (device == null) {
      localStorage.removeItem(SELECTED_DEVICE_LOCAL_STORAGE_KEY);
      this.selectedDevice = undefined;

      return;
    }
    if (device.purchaseDate instanceof Date) {
      const formattedDate = device.purchaseDate.toLocaleDateString('en-GB').split('/').reverse().join('-');
      device.purchaseDate = formattedDate;
    }
    this.selectedDevice = _cloneDeep(device);
    localStorage.setItem(SELECTED_DEVICE_LOCAL_STORAGE_KEY, JSON.stringify(this.selectedDevice));
  }

  public getAllDevices(): PghUserDeviceBase[] | undefined {
    return _cloneDeep(this.allDevices);
  }

  public setAllDevices(allDevices: PghUserDeviceBase[]) {
    if (allDevices == null) {
      localStorage.removeItem(ALL_DEVICES_LOCAL_STORAGE_KEY);
      this.allDevices = undefined;

      return;
    }

    this.allDevices = _cloneDeep(allDevices);
    localStorage.setItem(ALL_DEVICES_LOCAL_STORAGE_KEY, JSON.stringify(this.allDevices));
  }

  public removeDeviceFromAllDevices(device: PghUserDeviceBase) {
    _remove(this.allDevices ?? [], { registeredDeviceIdentifier: device?.registeredDeviceIdentifier });
    this.setAllDevices(this.allDevices);
  }

  public removeDeviceNumberFromAllDevices(registeredDeviceIdentifier: string) {
    _remove(this.allDevices ?? [], { registeredDeviceIdentifier: registeredDeviceIdentifier });
    this.setAllDevices(this.allDevices);
  }

  public updateAllDevices(addedDevice: PghUserDeviceBase) {
    // If device is in the AllDevices list, then remove it.
    const allDevices = this.getAllDevices().filter(x => x.elitaDeviceId !== addedDevice.elitaDeviceId);
    allDevices.push(addedDevice);
    this.setAllDevices(allDevices);
  }
}
